import styled from 'styled-components';

import {
  subMenuDropdownBackground,
  primaryColorLight,
  primaryColorWeak,
} from '../../config/colors';

export const OtherRelevantDocumentsWrapper = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    background-color: ${subMenuDropdownBackground};
    padding: 55px 35px 100px 25px;

    @media print {
        background-color: inherit;
    }
`;

export const TableWrapper = styled.div`
  width: 100%;
  table {
    width: 100%;
    text-align: center;
    border-spacing: 0;
    border-collapse: collapse;
    background-color: white;
    table-layout: fixed;
    word-break: break-word;
  }
  td,
  th {
    padding: 10px;
    border: 2px solid ${primaryColorLight};
  }
  th {
    background-color: ${primaryColorWeak};
  }
  tr {
    td:first-child {
      width: 19%;
    }
    td:nth-child(2) {
      width: 19%;
    }
    td:nth-child(3),
    td:nth-child(4),
    td:nth-child(5) {
      width: 14%;
    }
    td:nth-child(6) {
      width: 8%;
    }
    td:nth-child(7) { 
      width: 12%;
      padding: 0;
    }
  }

  @media print {
    table {
    table-layout: fixed;
      th, 
      td {
         padding: 7px;
         overflow: hidden;
      }
    }
  }
`;
